import Reflux from 'reflux';
import InvitationActions from 'actions/Invitation';
import AppActions from 'actions/App';
import SteelCompass from 'services/SteelCompass';

var InvitationStore = Reflux.createStore({
  listenables: [InvitationActions],
  data: {
    loading: true,
    selection: [],
    circles: [],
    groups: [],
    total: 0,
    status: {
      loading: true,
      state: null
    },
    invitation: {
      loading: true,
      accepting: false,
      accepted: false
    }
  },
  getInitialState() {
    return this.data;
  },
  countByCourseId(courseId) {
    return SteelCompass.call(
      'invitation',
      'countByCourseId',
      { courseId },
      response => {
        this.data.total = response.data;
        this.trigger(this.data);
      }
    );
  },
  showInfo(id) {
    this.data = {
      ...this.data,
      loading: true
    };
    this.trigger(this.data);
    return SteelCompass.request('invitation', 'showInfo', { id }).then(
      response => {
        let course = response.course;
        if (typeof course === 'object') {
          course = [course];
        }
        InvitationActions.showInfoComplete({
          ...response,
          course
        });
      },
      errorMsg => {
        AppActions.genericError(errorMsg);
        this.data.invitation = {
          ...this.data.invitation,
          loading: false
        };
        this.trigger(this.data);
      }
    );
  },
  showInfoComplete(invitation) {
    this.data.invitation = {
      ...this.data.invitation,
      ...invitation,
      loading: false
    };
    this.trigger(this.data);
  },
  onResend(id) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.request('invitation', 'resend', { id }).then(
      data => {
        InvitationActions.resendComplete(id);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onDelete(id) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.request('invitation', 'delete', { id }).then(
      data => {
        InvitationActions.deleteComplete(id);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onDeleteComplete(id) {
    const { selection } = this.data;
    for (var i = selection.length; i--; ) {
      if (selection[i].id === id) {
        selection.splice(i, 1);
      }
    }
    this.trigger(this.data);
  },
  onFindByGroupId(groupId) {
    return SteelCompass.request('invitation', 'findByCircleId', {
      circleId: groupId,
      sortBy: 'name',
      sortMode: 'asc'
    }).then(
      invitations => {
        InvitationActions.findByGroupIdComplete(invitations);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onFindByGroupIdComplete(invitations) {
    this.data.selection = invitations;
    this.trigger(this.data);
  },
  onFindByCourseId(courseId, pageStart, pageLength, unusedOnly) {
    return SteelCompass.request(
      'invitation',
      'findByCourseId',
      { courseId: courseId, unusedOnly: 1, sortBy: 'name', sortMode: 'asc' },
      pageStart,
      pageLength
    ).then(
      invitations => {
        InvitationActions.findByCourseIdComplete(invitations);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onFindByCourseIdComplete(invitations) {
    this.data.selection = invitations;
    this.trigger(this.data);
  },
  check(hash) {
    this.data = {
      ...this.data,
      inivtation: {
        ...this.data.invitation,
        loading: true
      }
    };
    this.trigger(this.data);
    return SteelCompass.request('guest', 'checkInvitation', { hash }).then(
      response => {
        const [invitation] = response;
        InvitationActions.checkComplete(invitation);
      },
      error => {
        AppActions.genericError(error);
        this.data = {
          ...this.data,
          inivtation: {
            ...this.data.invitation,
            loading: false
          }
        };
        this.trigger(this.data);
      }
    );
  },
  checkGiftCode(giftCode) {
    this.data = {
      ...this.data,
      inivtation: {
        ...this.data.invitation,
        loading: true
      }
    };
    this.trigger(this.data);
    return SteelCompass.request('guest', 'checkInvitation', { giftCode }).then(
      response => {
        const [invitation] = response;
        InvitationActions.checkComplete(invitation);
      },
      error => {
        this.data = {
          ...this.data,
          invitation: {
            ...this.data.invitation,
            loading: false,
            error: true
          }
        };
        this.trigger(this.data);
      }
    );
  },
  checkComplete(invitation) {
    this.data = {
      ...this.data,
      error: false,
      invitation: {
        ...this.data.invitation,
        ...invitation,
        loading: false
      }
    };
    this.trigger(this.data);
  },
  getInvitationEmailStatus(invitationId) {
    this.data = {
      ...this.data,
      status: {
        loading: true,
        state: null
      }
    };
    this.trigger(this.data);
    return SteelCompass.request('vendor/mandrill', 'getInvitationEmailStatus', {
      invitationId
    }).then(
      response => {
        InvitationActions.getInvitationEmailStatusComplete(response);
      },
      error => {
          this.data = {
            ...this.data,
            status: {
              loading: false,
              state: 'unknown'
            }
          };

        this.trigger(this.data);
      }
    );
  },
  getInvitationEmailStatusComplete(state) {
    this.data = {
      ...this.data,
      status: {
        loading: false,
        state
      }
    };
    this.trigger(this.data);
  },
  accept(hash) {
    this.data = {
      ...this.data,
      invitation: {
        ...this.data.invitation,
        accepted: false,
        accepting: true
      }
    };
    this.trigger(this.data);
    return SteelCompass.request('guest', 'acceptInvitation', { hash }).then(
      data => {
        InvitationActions.acceptComplete(data);
      },
      error => {
        AppActions.genericError(error);
        this.data = {
          ...this.data,
          invitation: {
            ...this.data.invitation,
            accepted: false,
            accepting: true
          }
        };

        this.trigger(this.data);
      }
    );
  },
  acceptGift(giftCode) {
    this.data = {
      ...this.data,
      invitation: {
        ...this.data.invitation,
        accepted: false,
        accepting: true
      }
    };
    this.trigger(this.data);
    return SteelCompass.request('guest', 'acceptInvitation', { giftCode }).then(
      data => {
        InvitationActions.acceptComplete(data);
      },
      error => {
        AppActions.genericError(error);
        this.data = {
          ...this.data,
          loading: false,
          invitation: {
            ...this.data.invitation,
            accepted: false,
            accepting: true,
          }
        };

        this.trigger(this.data);
      }
    );
  },
  acceptComplete(data) {
    const [invitation] = data;
    this.data = {
      ...this.data,
      invitation: {
        ...this.data.invitation,
        ...invitation,
        accepted: true,
        accepting: false
      }
    };
    this.trigger(this.data);
  }
});

export default InvitationStore;



// WEBPACK FOOTER //
// ./src/js/stores/Invitation.js